import { Col, Form, Input, Row } from "antd";
import { useEffect } from "react";

import { useNavigate, useParams } from "react-router-dom";
import { ButtonProps } from "../../../../../helpers/constants";
import useAxiosPost from "../../../../../hooks/useAxiosPost";
import useMultiNotification from "../../../../../hooks/useNotification";
import NetwalaButton from "../../../../Items/Button/Index";
import PlusIcon from "./../../../../../assets/svgs/IconsWhite/PlusIcon.svg";
const CreateVlanComponent = () => {
  const [
    postApiData,
    apiResponse,
    apiError,
    apiLoading,
    apiMessage,
    apiErrorCount,
  ] = useAxiosPost<CreateVlanByIspApiProp>("isps/vlans/createVLAN", true);
  const { openNotification, contextHolder } = useMultiNotification();
  const { intPkIspID } = useParams();

  const [form] = Form.useForm();
  const navigate = useNavigate();
  const onFinish = (values: any) => {
    const dataToSend: CreateVlanByIspApiProp = {
      intPkIspID: Number(intPkIspID),
      vlanValue: Number(values.vlanValue),
    };
    postApiData(dataToSend);
  };

  const onFinishFailed = (errorInfo: any) => {
    console.log("Failed:", errorInfo);
  };

  useEffect(() => {
    if (apiResponse !== null) {
      const { message } = apiResponse;
      if (message) {
        openNotification(`success`, "Success", message);
        setTimeout(() => {
          navigate(-1);
        }, 3000);
      }
    }
  }, [apiResponse]);
  useEffect(() => {
    if (apiError !== null && apiErrorCount !== 0) {
      openNotification(`error`, "Operation Failed", apiError);
    }
  }, [apiError, apiErrorCount]);

  return (
    <>
      {contextHolder}

      <Row style={{ width: "100%" }}>
        <Form
          name="createPackageForm"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          layout="vertical"
          requiredMark={false}
          style={{ width: "100%" }}
          form={form}
        >
          {/* First */}

          <Row gutter={16}>
            <Col offset={6} span={12}>
              <Form.Item
                label={
                  <span className="create-user-form-label">Vlan Value</span>
                }
                name="vlanValue"
                rules={[
                  {
                    required: true,
                    message: "Please enter Sale Price",
                  },
                  {
                    validator: (_, value) =>
                      value >= 0
                        ? Promise.resolve()
                        : Promise.reject(
                            new Error("Vlan Value Must be greater than 0")
                          ),
                  },
                ]}
              >
                <Input
                  type="number"
                  defaultValue={0}
                  className="user-input-general-height"
                  placeholder="100"
                />
              </Form.Item>
            </Col>
          </Row>

          {/* Final */}
          <Row>
            <Col
              style={{ display: "flex", justifyContent: "center" }}
              span={24}
            >
              <Form.Item>
                <NetwalaButton
                  htmlType="submit"
                  backgroundColor={ButtonProps.background.STANDARD}
                  height={ButtonProps.height.STANDARD}
                  width={ButtonProps.width.STANDARD}
                  textColor={ButtonProps.color.STANDARD}
                  onClick={() => {
                    console.log("clicked");
                  }}
                  text="Create Vlan"
                  icon={<img src={PlusIcon} />}
                  disabled={apiLoading}
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Row>
    </>
  );
};
export default CreateVlanComponent;
